<template>
    <div>
        <v-form>
            <validation-observer
                    ref="observer"
            >
                <h3>Class Details</h3>
                <v-row>
                    <v-col cols="12">
                        <validation-provider
                                v-slot="{ errors }"
                                name="Course Title"
                                rules="required"
                        >
                            <v-text-field
                                    v-model="trainingClass.title"
                                    hint="Course Title - Will be used on certificates"
                                    label="Course Title *"
                                    :error-messages="errors"
                                    required
                            ></v-text-field>
                        </validation-provider>
                    </v-col>

                    <v-col cols="6">
                        <validation-provider
                                v-slot="{ errors }"
                                name="Start Date"
                                :rules="'required'"
                        >
                            <DatePicker
                                    v-model="trainingClass.startDate"
                                    label="Start Date *"
                                    :error-messages="errors"
                                    required
                            />
                        </validation-provider>
                    </v-col>
                    <v-col cols="3">
                        <validation-provider
                                v-slot="{ errors }"
                                name="Length (days)"
                                rules="required"
                        >
                            <v-text-field
                                    v-model="trainingClass.days"
                                    type="number"
                                    label="Length (days) *"
                                    :error-messages="errors"
                                    required
                            />
                        </validation-provider>
                    </v-col>

                    <v-col cols="3">
                        <validation-provider
                                v-slot="{ errors }"
                                name="Delegates"
                                rules="required"
                        >
                            <v-text-field
                                    v-model="trainingClass.delegates"
                                    type="number"
                                    label="Delegates *"
                                    :error-messages="errors"
                                    required
                            />
                        </validation-provider>
                    </v-col>
                    <v-col cols="12">
                        <h3>Location</h3>
                        <v-radio-group
                                v-model="locationType"
                                row
                                label="Training Location *"
                                @change="updateLocationType"
                        >
                            <v-radio
                                    label="Virtual"
                                    value="virtual"
                            ></v-radio>
                            <v-radio
                                    label="On-Site"
                                    value="on-site"
                            ></v-radio>
                            <v-radio
                                    label="Training Center"
                                    value="training-center"
                            ></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" v-if="locationType === 'virtual'">
                        <validation-provider
                                v-slot="{ errors }"
                                name="Virtual Platform"
                                :rules="`${locationType === 'virtual' ? 'required' : ''}`"
                        >
                            <v-select
                                    v-model="trainingClass.virtualPlatform"
                                    :items="virtualPlatforms"
                                    label="Virtual Platform *"
                                    :error-messages="errors"
                            />
                        </validation-provider>
                    </v-col>
                    <v-col cols="12" v-if="locationType === 'training-center'">
                        <validation-provider
                                v-slot="{ errors }"
                                name="Training Center"
                                :rules="`${locationType === 'training-center' ? 'required' : ''}`"
                        >
                            <TrainingCenterSelector
                                    v-model="trainingClass.trainingCenter"
                                    :error-messages="errors"
                            />
                        </validation-provider>
                    </v-col>

                  <v-col cols="6" v-if="locationType === 'on-site'">
                    <validation-provider
                        v-slot="{ errors }"
                        name="Address *"
                        :rules="`${locationType === 'on-site' ? 'required' : ''}`"

                    >
                      <v-text-field
                          v-model="trainingClass.shipAddress1"
                          label="Address *"
                          :error-messages="errors"
                          dense
                      />
                    </validation-provider>
                    <v-text-field
                        v-model="trainingClass.shipAddress2"
                        dense
                    />
                    <v-text-field
                        v-model="trainingClass.shipAddress3"
                        dense
                    />
                    <validation-provider
                        v-slot="{ errors }"
                        name="Town *"
                        :rules="`${locationType === 'on-site' ? 'required' : ''}`"
                    >
                      <v-text-field
                          v-model="trainingClass.shipTown"
                          label="Town *"
                          :error-messages="errors"
                          dense
                      />
                    </validation-provider>
                    <v-row>
                    <v-col cols="6">
                    <v-text-field
                        v-model="trainingClass.shipCounty"
                        label="County"
                        :error-messages="errors"
                        dense
                    />
                    </v-col>
                    <v-col cols="6">
                    <validation-provider
                        v-slot="{ errors }"
                        name="Postcode *"
                        :rules="`${locationType === 'on-site' ? 'required' : ''}`"
                    >
                      <v-text-field
                          v-model="trainingClass.shipPostcode"
                          label="Postcode *"
                          :error-messages="errors"
                          dense
                      />
                    </validation-provider>
                    </v-col>
                    </v-row>

                  </v-col>
                  <v-col cols="6" v-if="locationType === 'on-site'">
                    <validation-provider
                        v-slot="{ errors }"
                        name="Contact"
                        :rules="`${locationType === 'on-site' ? 'required' : ''}`"
                    >
                      <v-text-field
                          v-model="trainingClass.shipContact"
                          label="Contact Name *"
                          :error-messages="errors"
                          dense
                      />
                    </validation-provider>
                    <validation-provider
                        v-slot="{ errors }"
                        name="Contact Mobile"
                        :rules="`${locationType === 'on-site' ? 'required' : ''}`"
                    >
                      <v-text-field
                          v-model="trainingClass.shipMobile"
                          label="Contact Mobile"
                          :error-messages="errors"
                          dense
                      />
                    </validation-provider>

                  </v-col>

                    <v-col cols="12">
                        <h3>Trainer</h3>
                    </v-col>
                    <v-col cols="6">
                        <validation-provider
                                v-slot="{ errors }"
                                name="Trainer"
                                rules="required"
                        >
                            <TrainerSelector
                                    v-model="trainingClass.trainer"
                                    label="Trainer *"
                                    :error-messages="errors"
                            />
                        </validation-provider>
                    </v-col>
                    <v-col cols="6">
                        <v-checkbox
                                v-model="trainingClass.createPO"
                                label="Generate Purchase Order"
                        />
                    </v-col>
                    <v-col cols="6">
                        <validation-provider
                                v-slot="{ errors }"
                                name="Day Rate "
                                :rules="`${trainingClass.createPO ? 'required' : ''}`"
                        >
                            <v-text-field
                                    v-if="trainingClass.createPO"
                                    v-model="trainingClass.dayRate"
                                    label="Day Rate *"
                                    prefix="£"
                                    :error-messages="errors"
                            />
                        </validation-provider>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                                v-if="trainingClass.createPO "
                                :disabled="locationType !== 'on-site'"
                                v-model="trainingClass.travelRate"
                                label="Travel Day Rate"
                                prefix="£"
                        />
                    </v-col>
                    <v-col cols="12" class="d-flex">
                        <v-spacer></v-spacer>

                        <v-btn
                                color="green darken-1"
                                dark
                                @click="buildTrainingClass"
                        >
                            Create
                        </v-btn>
                    </v-col>
                </v-row>
            </validation-observer>
        </v-form>
    </div>
</template>

<script>

    import TrainerSelector from "../../AutoCompletes/TrainerSelector";
    import TrainingCenterSelector from "../../AutoCompletes/TrainingCenterSelector";
    import moment from "moment";
    import TRAINING_CLASS_BUILD from "../../../graphql/TrainingClass/Build.gql";
    import {required} from 'vee-validate/dist/rules'
    import {extend, ValidationObserver, ValidationProvider, setInteractionMode} from 'vee-validate'
    import DatePicker from "../../DatePicker";

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        components: {
            TrainerSelector,
            TrainingCenterSelector,
            ValidationProvider,
            ValidationObserver,
            DatePicker,
        },
        props: {
            booking: Object,
        },
        data() {
            return {
                trainingClass: {
                    booking: this.booking.id,
                    title: this.booking.courseTitle,
                    startDate: null,
                    days: this.booking.days,
                    delegates: this.booking.delegates > 0 ? this.booking.delegates : 1 ,
                    trainingCenter: '5',
                    trainer: null,
                    deliveryFormat: 'virtual',
                    createPO: true,
                    dayRate: null,
                    travelRate: 0,
                    shipContact: null,
                    shipMobile: null,
                    shipAddress1: null,
                    shipAddress2: null,
                    shipAddress3: null,
                    shipTown: null,
                    shipCounty: null,
                    shipPostcode: null,
                    virtualPlatform: 'ZOOM',
                },
                locationType: 'virtual',
                virtual: true,
                virtualPlatform: 'ZOOM',
                pickerOpen: false,
                virtualPlatforms: [
                    'ZOOM',
                    'M-TEAMS',
                    'SKYPE',
                    'WEB-EX',
                    'TBA',
                    'OTHER',
                ]
            }
        },
        computed: {
            formattedStartDate() {
                if (this.startDate === null) {
                    return ''
                }
                return moment(this.startDate).format("ddd, D MMMM YYYY");
            }

        },
        methods: {
            updateLocationType(locationType) {
                this.trainingClass.virtualPlatform = null;
                this.trainingClass.deliveryFormat = this.locationType;
                if (locationType === 'virtual') {
                    this.trainingClass.virtualPlatform = 'ZOOM';
                    this.trainingClass.trainingCenter = '5';
                }

                if (locationType === 'on-site') {
                    this.trainingClass.trainingCenter = '0';
                }
            },

            buildTrainingClass() {
                this.$refs.observer.validate().then((valid) => {
                    if(!valid) return

                    this.updating = true
                    this.$apollo.mutate({
                        mutation: TRAINING_CLASS_BUILD,
                        variables: {input: this.trainingClass},
                    }).then(() => {
                        this.$emit('complete')
                        this.updating = false
                        this.$store.dispatch('notification/addSuccess', 'Training Class Built Successfully')
                    }).catch((error) => {
                        this.updating = false
                        this.$store.dispatch('notification/handleGraphQlError', error)
                    })
                });

            },
            validate () {
                return this.$refs.observer.validate()
            },
        },
    }
</script>

<style scoped>

</style>